import { getEventLabel } from '@odo/shared-ui';
import type { DmNotification } from '../../../services/dmNotifications';

export function notificationTitle(notification: DmNotification): string {
    return (
        notification.finding?.title ?? notification.title ?? getEventLabel(notification.eventType)
    );
}

function joinLines(lines: readonly string[] | undefined): string | null {
    const text = (lines ?? [])
        .map((line) => line.trim())
        .filter(Boolean)
        .join('\n');
    return text || null;
}

export interface NotificationInstructions {
    patient: string | null;
    team: string | null;
}

// Without a finding, DM's free text is the team's instruction.
export function instructionTexts(notification: DmNotification): NotificationInstructions {
    const { finding } = notification;
    if (!finding) return { patient: null, team: notification.content?.trim() || null };
    return {
        patient: joinLines(finding.patientInstructions),
        team: joinLines(finding.teamInstructions)
    };
}
